import * as React from 'react';
import AttachmentsListRow from './CommunicationAttachmentsListRow';
import { Table } from 'react-bootstrap';
import { IAttachments } from '../Types';

interface IProps {
    items: IAttachments[];
    download: (WarmStorageReference: string) => void;
}

const CommunicationAttachmentList = (props: IProps) => {
    return (
        <Table responsive>
            <thead>
                <tr className="table_header"></tr>
            </thead>
            <tbody>
                {props.items.map((e: IAttachments, index: number) => {
                    return <AttachmentsListRow items={e} index={index} download={props.download} />;
                })}
            </tbody>
        </Table>
    );
};

export default CommunicationAttachmentList;
